import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import SearchBar from "../../components/SearchBar";
import { Box, Button, Tab, Tabs } from "@mui/material";
import AddNotification from "../../Modals/addNotification";
import AddIcon from "@mui/icons-material/Add";
import NotificationsList from "../../features/manageNotifications/notificationsList";
import {
  useLazyGetBroadcastNotificationsQuery,
  useLazyGetUserNotificationsQuery,
} from "../../service/notification";
import { showError } from "../../constants/toasts";
import Loader from "../../constants/Loader";
import CustomPagination from "../../components/CustomPagination";
import { isValidInput } from "../../utils/validations";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { formatDubaiDateTime } from "../../utils/dateTime";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageNotifications = () => {
  const navigate = useNavigate();
  const [getNotifications] = useLazyGetBroadcastNotificationsQuery();
  const [getUserNotifications] = useLazyGetUserNotificationsQuery();

  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const [loading, setLoading] = useState(false);
  const [notificationData, setNotificationData] = useState([]);
  const [userNotificationData, setUserNotificationData] = useState([]);
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [count, setCount] = useState(10);
  const [valueTabs1, setValueTabs1] = useState(0);
  const handleChangeTabs1 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs1(newValue);
    setPage(1);
  };

  const columns: GridColDef[] = [
    {
      flex: 1,
      minWidth: 150,
      field: "title",
      headerName: "Title",
      editable: false,
      sortable: false,
      renderCell: ({ row }: any) => {
        return (
          <div className="user_block click_action">
            <p>
              <b>{row?.title || "-"}</b>
            </p>
          </div>
        );
      },
    },
    {
      flex: 2,
      minWidth: 200,
      field: "body",
      headerName: "Body",
      editable: false,
      sortable: false,
      renderCell: ({ row }: any) => {
        return (
          <div className="user_block click_action">
            <p>
              <b>{row?.body || "-"}</b>
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "type",
      headerName: "Type",
      editable: false,
      sortable: false,
      renderCell: ({ row }: any) => {
        return (
          <div className="user_block click_action">
            <p>
              <b>{row?.notificationType || "-"}</b>
            </p>
          </div>
        );
      },
    },
    {
      minWidth: 250,
      field: "date",
      headerName: "Created Date",
      editable: false,
      sortable: false,
      renderCell: ({ row }: any) => {
        return (
          <div className="user_block click_action">
            <p>
              <b>
                {row?.createdAt ? formatDubaiDateTime(row?.createdAt) : "-"}
              </b>
            </p>
          </div>
        );
      },
    },
  ];

  let hidden = ["fullName"];

  const getNotificationsApi = async () => {
    setLoading(true);
    try {
      const response = await getNotifications({
        page: page,
        search: debouncedSearchTerm?.trim(),
      }).unwrap();

      setLoading(false);

      if (response.status === 200) {
        setNotificationData(response?.data?.items || []);
        setCount(response?.data?.totalCount);
      } else {
        setNotificationData([]);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const getUserNotificationsApi = async () => {
    setLoading(true);
    try {
      const response = await getUserNotifications({
        page: page,
        search: debouncedSearchTerm?.trim(),
      }).unwrap();

      setLoading(false);

      if (response.status === 200) {
        setUserNotificationData(response?.data?.items || []);
        setCount(response?.data?.totalCount);
      } else {
        setUserNotificationData([]);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getNotificationsApi();

    if (valueTabs1 === 1) {
      getUserNotificationsApi();
    }
  }, [debouncedSearchTerm, page, valueTabs1]);

  return (
    <MainContainer>
      <Loader isLoad={loading} />
      <div className="main_title d_flex">
        <h1>Manage Notifications</h1>
        <div className="right_s">
          <div className="table_header">
            <div className="left_s">
              <SearchBar
                searchTerm={searchTerm}
                placeholder="Search...."
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                value={searchTerm}
                onCross={() => setSearchTerm("")}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
            </div>
            <div className="right_s">
              <Button
                className="btn btn_primary"
                onClick={() => setOpenModal(true)}
              >
                <AddIcon /> Add Notification
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="cards table_cards v2">
        <Box className="custom_tabs" sx={{ width: "100%" }}>
          <Tabs
            value={valueTabs1}
            onChange={handleChangeTabs1}
            aria-label="basic tabs example"
            className="custom_tabs_links"
          >
            <Tab label="Notifications" {...a11yProps(0)} />
            <Tab label="System Generated" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={valueTabs1} index={0}>
          <NotificationsList data={notificationData} />
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs1} index={1}>
          <div className="sorting_table">
            <TableComponent columns={columns} rows={userNotificationData} />
          </div>
        </CustomTabPanel>
      </div>
      {notificationData?.length ? (
        <CustomPagination
          currentPage={page - 1}
          totalPages={Math.ceil(count / 10)}
          count={count}
          pageSize={10}
          onPageChange={(page) => setPage(page + 1)}
        />
      ) : null}

      <AddNotification
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
        getNotificationsApi={getNotificationsApi}
      />
    </MainContainer>
  );
};

export default ManageNotifications;
